import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export function FiltersInfoMessage() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        paddingX: 2,
      }}
    >
      <CbhIcon type="info" size="small" />
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.secondary,
        })}
      >
        The filters below are saved even if you close the app
      </Text>
    </Box>
  );
}
